/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Backup_Saved_SuccessfullyInputs */



/**
* | output |
* | --- |
* | "Automatic backup saved successfully" |
*
* @param {Automatic_Save_Backup_Saved_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_backup_saved_successfully = /** @type {((inputs?: Automatic_Save_Backup_Saved_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Backup_Saved_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sauvegarde automatique enregistrée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Sicherung erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Backup automatico salvato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое резервное копирование успешно сохранено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copia de seguridad automática guardada correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动备份已成功保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動バックアップが正常に保存されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित बैकअप सफलतापूर्वक सहेज लिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cópia de segurança automática salva com sucesso.")
	return /** @type {LocalizedString} */ ("Automatic backup saved successfully")
});